<template>
  <v-card class="bg-surface my-5 card-clean" elevation="1">
    <Splide
      v-if="imgSrc.length > 1"
      :options="{ rewind: true }"
      class="splide max-height"
    >
      <SplideSlide v-for="img in imgSrc" :key="img" class="d-flex max-height">
        <v-img
          @click="() => fullscreen(img, $event)"
          :lazy-src="require(`./../assets/images/${img}_lowres.jpg`)"
          transition="true"
          :alt="`${productName} – Massivholzmöbel von Schreinerei M² Pfullingen`"
          cover
          :src="require(`./../assets/images/${img}.jpg`)"
        ></v-img>
        <v-overlay
          v-model="overlay"
          @click="overlay = false"
          class="align-center justify-center"
        >
          <div class="fullscreenImg">
            <v-img
              :lazy-src="require(`./../assets/images/${fsImage}_lowres.jpg`)"
              transition="true"
              :alt="`${productName} – Schreinerei M²`"
              :src="require(`./../assets/images/${fsImage}.jpg`)"
            ></v-img>
          </div>
        </v-overlay>
      </SplideSlide>
    </Splide>
    <v-img
      v-else
      :lazy-src="require(`./../assets/images/${imgSrc[0]}_lowres.jpg`)"
      transition="true"
      :alt="`${productName} – Massivholzmöbel von Schreinerei M² Pfullingen`"
      :src="require(`./../assets/images/${imgSrc[0]}.jpg`)"
    ></v-img>
    <div class="pa-5">
      <h2 class="product-title">{{ productName }}</h2>
      <p v-if="productDescription" class="product-desc mt-1">{{ productDescription }}</p>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "Product",
  props: {
    imgSrc: Array,
    productDescription: String,
    productName: String,
    productPrice: String,
    imgHeight: String,
    buyButton: Boolean,
  },
  data: () => ({
    overlay: false,
    zIndex: 0,
    fsImage: null,
  }),
  mounted() {
    for (let element of document.getElementsByClassName("splide")) {
      element.style.setProperty("--height", this.imgHeight);
    }
  },
  methods: {
    fullscreen(img) {
      this.fsImage = img;
      this.overlay = !this.overlay;
    },
  },
};
</script>

<style scoped>
.card-clean {
  border-radius: 12px;
  overflow: hidden;
}

.splide {
  --height: 210px;
  display: flex;
  flex-direction: column;
  left: 0;
  min-width: 100%;
  max-height: 80vh;
  height: var(--height);
  overflow: clip;
}

.fullscreenImg {
  height: 100dvh;
  width: 100vw;
  display: flex;
  flex-direction: column;
}

.max-height {
  max-height: 400px;
}

@media screen and (max-width: 959px) {
  .max-height {
    max-height: 250px;
  }
}

.product-title {
  font-family: "ManropeLight", Arial, Helvetica, sans-serif;
  font-weight: 400;
  font-size: 1.3em;
}

.product-desc {
  font-family: "ManropeLight", Arial, Helvetica, sans-serif;
  font-size: 0.9em;
  opacity: 0.7;
}
</style>
